import { render } from "./UpdateSong.vue?vue&type=template&id=88dfe5d4&scoped=true"
import script from "./UpdateSong.vue?vue&type=script&lang=js"
export * from "./UpdateSong.vue?vue&type=script&lang=js"

import "./UpdateSong.vue?vue&type=style&index=0&id=88dfe5d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-88dfe5d4"

export default script